import { useEffect } from 'react';

import { isAbortError } from 'src/lib/errors';
import { useErrorHandler } from 'src/services/useErrorHandler';
import { useResourceActions } from 'src/store/resource';
import { useCurrentWorkspaceId } from 'src/store/workspace';

/**
 * This hook is used to maintain the "resource" store state.
 */
export const useMaintainResourceStoreState = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const handleError = useErrorHandler();
  const resourceActions = useResourceActions();

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    // Create an abort controller, in case user selects another workspace before the fetch completes
    const abortController = new AbortController();

    resourceActions
      .queryWorkspaceResources(currentWorkspaceId, {
        abortSignal: abortController.signal,
      })
      .catch((error) => {
        if (isAbortError(error)) {
          return;
        }

        handleError(error);
      });

    // Clear the store when the workspace changes
    return () => {
      abortController.abort();
    };
  }, [resourceActions, currentWorkspaceId, handleError]);
};
